import React from 'react';
import ReactDOM from 'react-dom';
import { SnackbarProvider, withSnackbar } from 'notistack';

import { COLORS } from './constants';
import SnackbarAlert from './SnackbarAlert';

export default {
  success: function (msg) {
    this.toast(msg, COLORS.SUCCESS);
  },
  error: function (msg) {
    this.toast(msg, COLORS.ERROR);
  },
  info: function (msg) {
    this.toast(msg, COLORS.INFO);
  },
  warning: function (msg) {
    this.toast(msg, COLORS.WARNING);
  },
  toast: function (msg, variant) {
    const Display = withSnackbar(({ message, enqueueSnackbar }) => {
      enqueueSnackbar(message, {
        variant,
        content: () => <SnackbarAlert message={message} variant={variant} />,
        autoHideDuration: 2000
      });
      return null;
    });
    const mountPoint = document.getElementById('snackbarhelper');
    if (mountPoint) {
      ReactDOM.render(
        <SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
          <Display message={msg} variant={variant} />
        </SnackbarProvider>,
        mountPoint
      );
    }
  }
};
